export default __webpack_public_path__ + "static/media/checkout-screen.e15499bb.svg";